// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3hfYM"};